let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gwwAt")).then(() => parcelRequire('i0XRI'));